import utilActions from '@/api/actions';

const requestClearance = {
	id: 'requestClearance',
	selectionType: 'single',
	label: 'cargo.requestClearanceAction',
	functionality: 'ACT_REQUEST_CLEARANCE_CARGO',
	checkAvailability: function (row) {
		if (!row || row.length === 0 || !row[0]) {
			return false;
		}

		if (!canUserPerformAction(row[0], this.$store)) {
			return false;
		}

		if (
			row[0].loadingstatus == 'Unallocated' ||
			row[0].unloadingstatus == 'Unallocated' ||
			row[0].loadingstatus == 'ნომინირების გარეშე' ||
			row[0].unloadingstatus == 'ნომინირების გარეშე'
		) {
			return false;
		}
		if (
			(row[0].loadingstatus == 'Documentation pending' ||
				row[0].loadingstatus == 'Partially cleared' ||
				row[0].loadingstatus == 'Documentation rejected' ||
				row[0].unloadingstatus == 'Documentation pending' ||
				row[0].unloadingstatus == 'Partially cleared' ||
				row[0].unloadingstatus == 'Documentation rejected' ||
				row[0].loadingstatus == 'დოკუმენტაცია მოლოდინის რეჟიმშია' ||
				row[0].loadingstatus == 'ნაწილობრივი ნებართვა გაცემულია' ||
				row[0].loadingstatus == 'დოკუმენტაცია უარყოფილია' ||
				row[0].unloadingstatus == 'დოკუმენტაცია მოლოდინის რეჟიმშია' ||
				row[0].unloadingstatus == 'ნაწილობრივი ნებართვა გაცემულია' ||
				row[0].unloadingstatus == 'დოკუმენტაცია უარყოფილია') &&
			row[0].status != 0 &&
			row[0].status != 3
		) {
			return true;
		}
	},
	runAction: function (action, model, registries) {
		const row = {};
		const objectPk = utilActions.getPkFromModel(model, registries[0]);
		row.registries = registries[0];
		console.log('row', row);

		row.headerPk = objectPk;
		row.isAction = true;
		this.$puiEvents.$emit('pui-modalDialogForm-requestClearance-' + model.name + '-show', row);
	}
};

const rejectDocumentation = {
	id: 'rejectDocumentation',
	selectionType: 'single',
	label: 'cargo.rejectDocumentationAction',
	functionality: 'ACT_REJECT_DOCUMENTATION_CARGO',
	checkAvailability: function (row) {
		if (!row || row.length === 0 || !row[0]) {
			return false;
		}
		if (
			row[0].loadingstatus == 'Unallocated' ||
			row[0].unloadingstatus == 'Unallocated' ||
			row[0].loadingstatus == 'ნომინირების გარეშე' ||
			row[0].unloadingstatus == 'ნომინირების გარეშე'
		) {
			return false;
		}
		if (
			(row[0].loadingstatus == 'Clearance requested' ||
				row[0].unloadingstatus == 'Clearance requested' ||
				row[0].loadingstatus == 'მოთხოვნა ნებართვაზე გაგზავნილია' ||
				row[0].unloadingstatus == 'მოთხოვნა ნებართვაზე გაგზავნილია') &&
			row[0].status != 0 &&
			row[0].status != 3
		) {
			return true;
		}
	},
	runAction: function (action, model, registries) {
		const row = {};
		const objectPk = utilActions.getPkFromModel(model, registries[0]);
		row.registries = registries[0];
		row.headerPk = objectPk;
		row.isAction = true;
		this.$puiEvents.$emit('pui-modalDialogForm-rejectDocumentation-' + model.name + '-show', row);
	}
};

const confirmClearance = {
	id: 'confirmClearance',
	selectionType: 'single',
	label: 'cargo.confirmClearanceAction',
	functionality: 'ACT_CONFIRM_CLEARANCE_CARGO',
	checkAvailability: function (row) {
		if (!row || row.length === 0 || !row[0]) {
			return false;
		}
		if (
			row[0].loadingstatus == 'Unallocated' ||
			row[0].unloadingstatus == 'Unallocated' ||
			row[0].loadingstatus == 'ნომინირების გარეშე' ||
			row[0].unloadingstatus == 'ნომინირების გარეშე'
		) {
			return false;
		}
		if (
			(row[0].loadingstatus == 'Clearance requested' ||
				row[0].unloadingstatus == 'Clearance requested' ||
				row[0].loadingstatus == 'მოთხოვნა ნებართვაზე გაგზავნილია' ||
				row[0].unloadingstatus == 'მოთხოვნა ნებართვაზე გაგზავნილია') &&
			row[0].status != 0 &&
			row[0].status != 3
		) {
			return true;
		}
	},
	runAction: function (action, model, registries) {
		const row = {};
		const objectPk = utilActions.getPkFromModel(model, registries[0]);
		row.registries = registries[0];
		row.headerPk = objectPk;
		row.isAction = true;
		this.$puiEvents.$emit('pui-modalDialogForm-confirmClearance-' + model.name + '-show', row);
	}
};

const rejectClearance = {
	id: 'rejectClearance',
	selectionType: 'single',
	label: 'cargo.rejectClearanceAction',
	functionality: 'ACT_CONFIRM_CLEARANCE_CARGO',
	checkAvailability: function (row) {
		if (!row || row.length === 0 || !row[0]) {
			return false;
		}
		if (
			row[0].loadingstatus == 'Unallocated' ||
			row[0].unloadingstatus == 'Unallocated' ||
			row[0].loadingstatus == 'ნომინირების გარეშე' ||
			row[0].unloadingstatus == 'ნომინირების გარეშე'
		) {
			return false;
		}
		if (
			row[0].loadingstatus == 'Rejected' ||
			row[0].unloadingstatus == 'Rejected' ||
			row[0].loadingstatus == 'ნებართვა უარყოფილია' ||
			row[0].unloadingstatus == 'ნებართვა უარყოფილია'
		) {
			return false;
		}
		return (
			row[0].status != 0 &&
			row[0].status != 3 &&
			(row[0].loadingstatus != 'Unallocated' ||
				row[0].unloadingstatus != 'Unallocated' ||
				row[0].loadingstatus == 'ნომინირების გარეშე' ||
				row[0].unloadingstatus == 'ნომინირების გარეშე') &&
			(row[0].loadingstatus != 'Documentation pending' ||
				row[0].unloadingstatus != 'Documentation pending' ||
				row[0].loadingstatus != 'დოკუმენტაცია მოლოდინის რეჟიმშია' ||
				row[0].unloadingstatus != 'დოკუმენტაცია მოლოდინის რეჟიმშია')
		);
	},
	runAction: function (action, model, registries) {
		const row = {};
		const objectPk = utilActions.getPkFromModel(model, registries[0]);
		row.registries = registries[0];
		row.headerPk = objectPk;
		row.isAction = true;
		this.$puiEvents.$emit('pui-modalDialogForm-rejectClearance-' + model.name + '-show', row);
	}
};

const undoRejectClearance = {
	id: 'undoRejectClearance',
	selectionType: 'single',
	label: 'cargo.undoRejectClearanceAction',
	functionality: 'ACT_CONFIRM_CLEARANCE_CARGO',
	checkAvailability: function (row) {
		if (!row || row.length === 0 || !row[0]) {
			return false;
		}
		return (
			row[0].status !== 0 &&
			row[0].status !== 3 &&
			(row[0].loadingstatus === 'Rejected' ||
				row[0].loadingstatus === 'ნებართვა უარყოფილია' ||
				row[0].unloadingstatus === 'Rejected' ||
				row[0].unloadingstatus === 'ნებართვა უარყოფილია')
		);
	},
	runAction: function (action, model, registries) {
		const row = {};
		const objectPk = utilActions.getPkFromModel(model, registries[0]);
		row.registries = registries[0];
		row.headerPk = objectPk;
		row.isAction = true;
		this.$puiEvents.$emit('pui-modalDialogForm-undoRejectClearance-' + model.name + '-show', row);
	}
};

// Acción personalizada para auditoría extendida Cargo
const viewAuditCargo = {
	id: 'viewAuditCargo',
	icon: 'far fa-file-alt',
	selectionType: 'single',
	label: 'puiauditCargoExtended.action', 
	functionality: 'ACTION_PUI_AUDIT', 
	showInForm: true,
	checkAvailability: function () {
		return true;
	},
	runAction: function (action, model, registries) {
		const row = registries[0];

		const objectPk = utilActions.getPkFromModel(model, row);
		row.headerPk = objectPk;
		row.isAction = true;
		row.pk = registries[0].cargoclearanceid;
		row.registries = registries[0];

		this.$puiRequests.getRequest(
			'/cargo/auditExt',
			{
				cargoclearanceid: row.pk
			},
			(response) => {
				response.data.isAction = true;
				this.$puiEvents.$emit(
					'pui-modalDialogForm-viewAuditCargo-' + model.name + '-show',
					response.data
				);
			}
		);
	}
};


function canUserPerformAction(row, store) {
	const userCodes = store.getters.getSession.properties.GESTAUT_PROPERTIES_USER_TYPE_CODE_LIST;
	const cargoAgentIds = store.getters.getSession.properties.GESTAUT_PROPERTIES_USER_RELATED_ORGS;
	const hasShagAndCaag = userCodes.includes('SHAG') && userCodes.includes('CAAG');
	const cargoAgentId = `${row.cargoagentid}`;
	const isRelatedOrg = cargoAgentIds.some((orgId) => `${orgId}` === cargoAgentId);
	return !(hasShagAndCaag && !isRelatedOrg);
}

export default {
	gridactions: [requestClearance, rejectDocumentation, confirmClearance, rejectClearance, undoRejectClearance, viewAuditCargo ]
};
